var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 62,
    viewBox: "0 0 54 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.9609 27.2955C52.076 18.2808 48.2285 10.5816 41.3991 5.6874C32.2805 -0.831791 21.6613 -1.14131 15.1013 8.18287C8.77213 17.1395 18.1216 27.1408 15.1013 31.2805L12.4273 35.1495L25.1433 44.1255L29.1832 38.6896C33.6464 32.3445 25.3357 20.9698 27.952 17.1782C29.8758 14.5666 32.9153 15.8434 35.32 17.5651C38.2634 19.6156 39.8601 25.1482 40.2449 29.5395L52.9609 27.2955ZM15.7939 44.7058C10.9267 41.2238 5.25164 42.2684 2.48142 46.1954C-0.288797 50.1223 0.557661 55.5582 5.63639 59.1177C7.55618 60.582 9.96577 61.241 12.3587 60.956C14.7516 60.671 16.9414 59.4643 18.4679 57.5894C19.8056 55.5291 20.2754 53.019 19.774 50.6106C19.2727 48.2021 17.8411 46.0923 15.7939 44.7445V44.7058Z",
    stroke: "#78C2DD",
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9449_141489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.6948 32.7426C50.1587 29.2904 49.8557 25.7786 48.8074 22.4546C47.7591 19.1305 45.9908 16.0751 43.6272 13.5034C37.206 6.79564 28.6058 4.91774 21.7961 11.3916C15.2392 17.6246 21.2056 27.1393 18.2661 30.0513L15.4845 32.7014L24.4228 41.9782L28.4971 38.1887C33.1487 33.778 28.0972 23.3103 30.8628 20.6594C32.784 18.8379 35.1172 20.3631 36.814 22.1245C38.889 24.288 39.3258 28.9562 38.9552 32.5789L49.6948 32.7426ZM16.6555 40.9722C13.2318 37.416 8.43703 37.3492 5.50684 40.0867C2.57665 42.8242 2.52594 47.339 6.10397 50.999C7.44221 52.4794 9.30429 53.3877 11.3001 53.5335C13.2959 53.6793 15.2705 53.0513 16.8103 51.7811C17.5142 51.062 18.0686 50.2118 18.4418 49.2792C18.815 48.3466 18.9997 47.3499 18.9853 46.3461C18.9709 45.3422 18.7577 44.3509 18.358 43.4289C17.9582 42.5068 17.3797 41.672 16.6555 40.9722Z",
    fill: "#78C2DD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9449_141489"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.1589,
    height: 45.5349,
    fill: "white",
    transform: "matrix(0.0536666 -0.998559 -0.998559 -0.0536666 48.4697 55.5347)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlue);
export default __webpack_public_path__ + "static/media/blue.4990cedb0429f1ff9f6c007a16a519c0.svg";
export { ForwardRef as ReactComponent };